import styled from 'styled-components';
import theme from 'styles/theme';

export const TextHighlightGreen = styled.span`
  color: ${theme.colors.fontGreen};
`;
